// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__dpNLv","wrapper":"Modal_wrapper__0pl+Z","header":"Modal_header__oAc6p","close":"Modal_close__7h9A3","body":"Modal_body__4vY72"};